import { PUBLIC_URL, PDFCO_APP_URL } from "./common";


export const PAGES = {
  PDF_EDIT_ADD_HELPER: {
    id: "PDF_EDIT_ADD_HELPER",
    label: "PDF Edit Add Helper",
    // this is the main url that will be used to display everything
    path: "/",
  }
};